import React from 'react';
import { Checkbox } from '../../../ui';
import { useBuilderEditor } from '../../../../features/builder/BuilderEditorContext';

const ValidationTab = () => {
  const {
    optional, handleRequired, optionSelectionValidation, setOptionSelectionValidation,
    markUnsaved, selectedanswertype, scoreEnabled, handleScoreEnable, isActionNeeded,
  } = useBuilderEditor();

  return (
    <div className="builder-property-tab">
      <Checkbox
        label="Required"
        checked={!optional}
        onChange={(e) => handleRequired(e.target.checked)}
      />

      {isActionNeeded() && (
        <Checkbox
          label="Enable scoring"
          checked={scoreEnabled}
          onChange={(e) => handleScoreEnable(e.target.checked)}
        />
      )}

      {selectedanswertype === 'MULTIPLE_CHOICE' && (
        <div>
          <label className="builder-label">Selection validation</label>
          <select
            className="builder-ui-select"
            value={optionSelectionValidation.operator || ''}
            onChange={(e) => {
              setOptionSelectionValidation({
                ...optionSelectionValidation,
                operator: e.target.value || null,
                maximumCount: e.target.value === 'BETWEEN' ? optionSelectionValidation.maximumCount : null,
              });
              markUnsaved();
            }}
          >
            <option value="">None</option>
            <option value="EQUAL_TO">Exactly</option>
            <option value="AT_LEAST">At least</option>
            <option value="AT_MOST">At most</option>
            <option value="BETWEEN">Between</option>
          </select>
          {optionSelectionValidation.operator && (
            <>
              <input
                className="builder-ui-input builder-property-tab__spacer-top"
                type="number"
                placeholder="Count"
                value={optionSelectionValidation.count || ''}
                onChange={(e) => {
                  setOptionSelectionValidation({ ...optionSelectionValidation, count: parseInt(e.target.value, 10) || null });
                  markUnsaved();
                }}
              />
              {optionSelectionValidation.operator === 'BETWEEN' && (
                <input
                  className="builder-ui-input builder-property-tab__spacer-top"
                  type="number"
                  placeholder="Maximum count"
                  value={optionSelectionValidation.maximumCount || ''}
                  onChange={(e) => {
                    setOptionSelectionValidation({ ...optionSelectionValidation, maximumCount: parseInt(e.target.value, 10) || null });
                    markUnsaved();
                  }}
                />
              )}
              <input
                className="builder-ui-input builder-property-tab__spacer-top"
                placeholder="Validation message (optional)"
                value={optionSelectionValidation.validationMessage || ''}
                onChange={(e) => {
                  setOptionSelectionValidation({ ...optionSelectionValidation, validationMessage: e.target.value || null });
                  markUnsaved();
                }}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ValidationTab;
